import { Environment } from '@src/environment';
import { getJob } from './JobService';
import { getApiClientByBodyType } from '../ApiClients/getApiClientByBodyType';

export const getPostScene = async (jobId: string) => {
  const job = await getJob(jobId);
  const sceneFile = job.scenes.post;
  return sceneFile;
};

export const getStoryScene = async (jobId: string) => {
  const job = await getJob(jobId);
  const sceneFile = job.scenes.story;
  return sceneFile;
};

export const getPostSceneUrl = (jobId: string) => {
  return `${Environment.DIRECTUS_API_URL}/jobs/${jobId}/scenes/post`;
};

export const getStorySceneUrl = (jobId: string) => {
  return `${Environment.DIRECTUS_API_URL}/jobs/${jobId}/scenes/story`;
};

export const updatePostScene = async (jobId: string, fileContent: string) => {
  const data = new FormData();
  const file = createFileFromContent(fileContent, 'post', jobId);
  data.append('file', file);

  return await getApiClientByBodyType('formData').patch(
    `jobs/${jobId}/scenes/post`,
    data,
  );
};

export const updateStoryScene = async (jobId: string, fileContent: string) => {
  const data = new FormData();
  const file = createFileFromContent(fileContent, 'story', jobId);
  data.append('file', file);

  return await getApiClientByBodyType('formData').patch(
    `jobs/${jobId}/scenes/story`,
    data,
  );
};

export async function createPostScene(jobId: string, fileContent: string) {
  const data = new FormData();
  const file = createFileFromContent(fileContent, 'post', jobId);
  data.append('file', file);

  return await getApiClientByBodyType('formData').post(
    `jobs/${jobId}/scenes/post`,
    data,
  );
}

export async function createStoryScene(jobId: string, fileContent: string) {
  const data = new FormData();
  const file = createFileFromContent(fileContent, 'story', jobId);
  data.append('file', file);

  return await getApiClientByBodyType('formData').post(
    `jobs/${jobId}/scenes/story`,
    data,
  );
}

export async function generateCreativesFromScene(
  jobId: string,
  type: 'post' | 'story',
) {
  return getApiClientByBodyType('json').post(
    `jobs/${jobId}/scenes/${type}/generateCreatives`,
    {},
  );
}

function createFileFromContent(
  fileContent: string,
  type: 'post' | 'story',
  jobId: string,
): File {
  return new File([fileContent], `${type}_${jobId}.scene`, {
    type: 'application/octet-stream',
  });
}
